import { createFileRoute, Outlet, useLocation } from "@tanstack/react-router"
import ReportTrendPage from "@/app/report/trend/page"

function TrendReportLayout() {
  const location = useLocation()

  if (location.pathname === "/report/trend") {
    return <ReportTrendPage />
  }

  return <Outlet />
}

export const Route = createFileRoute("/report/trend")({
  component: TrendReportLayout,
})
